<!-- <template>
  <v-form ref="form" :disabled="!candidato.pode_atualizar_dados_pessoais">
    <v-card flat rounded="lg">
      <v-card-title class="subtitle-1 font-weight-bold primary--text"
        >Dados de identificação</v-card-title
      >
      <v-card-text class="pb-0">
        <v-row dense>
          <v-col xl="4" lg="4" md="4" cols="12">
            <v-text-field
              label="Meu ID"
              v-model="candidato.id"
              disabled
            ></v-text-field>
          </v-col>
          <v-col xl="4" lg="4" md="4" cols="12">
            <v-text-field
              label="*CPF"
              v-model="candidato.cpf"
              disabled
            ></v-text-field>
          </v-col>
          <v-col xl="4" lg="4" md="4" cols="12">
            <v-text-field
              label="*Data de nascimento"
              type="date"
              v-model="candidato.dtnasc"
              disabled
            ></v-text-field>
          </v-col>
          <v-col xl="12" lg="12" md="12" cols="12">
            <v-text-field
              label="*Nome completo"
              v-model="candidato.nome"
              autofocus
              :rules="[(v) => !!v || 'Informe seu nome completo']"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card flat rounded="lg">
      <v-card-title class="subtitle-1 font-weight-bold primary--text"
        >Nacionalidade/Localização</v-card-title
      >
      <v-card-text class="pb-0">
        <v-row dense>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-select
              label="*Nacionalidade"
              no-data-text="Nenhuma nacionalidade localizada"
              :items="nacionalidades"
              item-text="descricao"
              item-value="codigo"
              v-model="candidato.naturalidade"
              :rules="[(v) => !!v || 'Nacionalidade deve ser informada']"
            ></v-select>
          </v-col>
          <template v-if="candidato.naturalidade == 1">
            <v-col xl="1" lg="1" md="1" cols="12">
              <v-select
                label="*País"
                no-data-text="Nenhum país encontrado"
                :items="locais"
                item-value="codigo"
                item-text="descricao"
                v-model="candidato.pais"
                :rules="[(v) => !!v || 'País deve ser informado']"
              ></v-select>
            </v-col>
            <v-col xl="1" lg="1" md="1" cols="12">
              <v-select
                label="*UF"
                no-data-text="Nenhuma UF encontrada"
                :items="
                  locais.find((l) => l.codigo == candidato.pais)?.ufs || []
                "
                item-text="codigo"
                item-value="codigo"
                v-model="candidato.uf"
                :rules="[(v) => !!v || 'UF deve ser informada']"
              ></v-select>
            </v-col>
            <v-col xl="4" lg="4" md="4" cols="12">
              <v-select
                label="*Cidade"
                no-data-text="Nenhuma cidade localizada"
                :items="getCidadesSelecionar() || []"
                item-value="codigo"
                item-text="descricao"
                v-model="candidato.cidade"
                :rules="[(v) => !!v || 'Cidade deve ser informada']"
              ></v-select>
            </v-col>
            <v-col xl="3" lg="3" md="3" cols="12">
              <v-text-field
                label="*Bairro"
                ß
                no-data-text="Nenhum bairro encontrado"
                :items="locais"
                item-value="codigo"
                item-text="descricao"
                v-model="candidato.bairro"
                :rules="[(v) => !!v || 'Bairro deve ser informado']"
              ></v-text-field>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card flat rounded="lg">
      <v-card-title class="subtitle-1 font-weight-bold primary--text"
        >Contato</v-card-title
      >
      <v-card-text class="pb-0">
        <v-row dense>
          <v-col xl="6" lg="6" md="6" cols="12">
            <v-text-field
              label="*Telefone 1"
              v-mask="'(##) #########'"
              v-model="candidato.telefone1"
              :rules="[(v) => !!v || 'Telefone deve ser informado']"
            ></v-text-field>
          </v-col>
          <v-col xl="6" lg="6" md="6" cols="12">
            <v-text-field
              label="Telefone 2"
              v-mask="'(##) #########'"
              v-model="candidato.telefone2"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card flat rounded="lg">
      <v-card-title class="subtitle-1 font-weight-bold primary--text"
        >Outros dados</v-card-title
      >
      <v-card-text>
        <v-row dense>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-select
              label="*Sexo"
              no-data-text="Nenhum opção disponível"
              :items="generos"
              item-text="descricao"
              item-value="codigo"
              v-model="candidato.sexo"
              :rules="[(v) => !!v || 'Sexo deve ser informado']"
            ></v-select>
          </v-col>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-select
              label="*Cútis"
              no-data-text="Nenhuma opção disponível"
              item-text="descricao"
              item-value="codigo"
              :items="cutis"
              v-model="candidato.cutis"
              :rules="[(v) => !!v || 'Cútis deve ser informada']"
            ></v-select>
          </v-col>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-text-field
              label="Peso (Kg)"
              v-mask="pesoMask"
              v-model="candidato.peso"
              suffix="kgs"
              :rules="[
                (v) => !!v || 'Peso deve ser informado',
                (v) =>
                  /^[0-9]{2,}$/.test(v) || 'Peso deve ter pelo menos 2 dígitos',
                (v) =>
                  (v >= 10 && v <= 300) || 'Peso deve estar entre 50kg e 200kg',
              ]"
            ></v-text-field>
          </v-col>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-text-field
              label="Altura (m)"
              v-model="candidato.altura"
              suffix="m"
              v-mask="'#.##'"
              :rules="[
                (v) => !!v || 'Altura é obrigatória',
                (v) =>
                  /^[1-2]\.\d{2}$/.test(v) ||
                  'Altura deve estar no formato X.XX',
                (v) =>
                  (v >= 1 && v <= 2.5) || 'Altura deve estar entre 1m e 2.50m',
              ]"
            ></v-text-field>
          </v-col>
          <v-col xl="6" lg="6" md="6" cols="12">
            <v-autocomplete
              underlined
              label="*Escolaridade"
              no-data-text="Nenhuma opção disponível"
              :items="escolaridades"
              item-text="descricao"
              item-value="codigo"
              v-model="candidato.codescolaridade"
              :rules="[(v) => !!v || 'Escolaridade deve ser informada']"
            ></v-autocomplete>
          </v-col>
          <v-col
            xl="6"
            lg="6"
            md="6"
            cols="12"
            v-if="anexarCertificadoConclusao()"
          >
            <v-file-input
              label="Anexo Certificado Conclusão Curso"
              v-model="anexos.certificado_conclusao"
              :success="candidato.imgCertConclusao"
              :messages="
                candidato.imgCertConclusao ? 'Documento já enviado' : ''
              "
              :rules="[]"
            ></v-file-input>
          </v-col>
          <v-col xl="6" lg="6" md="6" cols="12" v-if="isGraduacaoSuperior">
            <v-autocomplete
              underlined
              v-model="candidato.curso"
              :items="cursosSuperiores"
              item-text="descricao"
              item-value="codigo"
              label="*Curso superior"
              clearable
              :rules="[(v) => !!v || 'Curso deve ser informado']"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="candidato.pode_atualizar_dados_pessoais">
        <v-row v-if="candidato.nivel == 1">
          <v-col cols="12">
            <v-btn
              rounded
              depressed
              block
              class="green lighten-4 primary--text font-weight-bold"
              @click="validarDadosPessoais()"
              >Continuar <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <v-btn
              rounded
              depressed
              block
              class="green lighten-4 primary--text font-weight-bold"
              @click="atualizar()"
              >Atualizar dados pessoais</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
export default {
  computed: {
    ...mapState([
      "candidato",
      "generos",
      "cutis",
      "escolaridades",
      "nacionalidades",
      "locais",
      "anexos",
      "cursosSuperiores",
    ]),
    isGraduacaoSuperior() {
      const esc = this.escolaridades.find(
        (e) => e.codigo === this.candidato.codescolaridade
      );
      return esc ? esc.graduacao : false;
    },
  },
  watch: {
    // Ao mudar a escolaridade, se for graduacao, busca os cursos
    "candidato.codescolaridade": function () {
      if (this.isGraduacaoSuperior) {
        this.getCursosSuperiores();
      }
    },
  },
  methods: {
    ...mapMutations(["addStep"]),
    ...mapActions(["confirmarInscricao", "getCursosSuperiores"]),
    getCidadesSelecionar() {
      if (this.candidato.uf && this.candidato.pais) {
        return this.locais
          .find((l) => l.codigo == this.candidato.pais)
          .ufs.find((uf) => uf.codigo == this.candidato.uf).cidades;
      }
      return [];
    },
    validarDadosPessoais() {
      if (this.$refs.form.validate()) {
        this.addStep();
      }
    },
    anexarCertificadoConclusao() {
      if (this.candidato.codescolaridade > 0) {
        const esc = this.escolaridades.find(
          (e) => e.codigo == this.candidato.codescolaridade
        );
        return esc ? esc.graduacao : false;
      }
      return false;
    },
    async atualizar() {
      this.atualizando = true;
      const insc = await this.confirmarInscricao();
      if (insc) {
        this.$router.go();
      }
      this.atualizando = false;
    },
  },
  data: () => ({
    atualizando: false,
    pesoMask: createNumberMask({
      prefix: "",
      suffix: "",
      includeThousandsSeparator: false,
      allowNegative: false,
      allowDecimal: false,
      requireDecimal: false,
      integerLimit: 3,
      decimalLimit: 3,
      decimalSymbol: ".",
    }),
    alturaMask: createNumberMask({
      prefix: "",
      suffix: "",
      includeThousandsSeparator: false,
      allowNegative: false,
      allowDecimal: true,
      requireDecimal: true,
      integerLimit: 1,
      decimalLimit: 2,
      decimalSymbol: ".",
    }),
  }),
  mounted() {
    // Se a escolaridade já estiver selecionada como graduacao, busca ao carregar
    if (this.isGraduacaoSuperior) {
      this.getCursosSuperiores();
    }
  },
};
</script>

<style></style> -->

<template>
  <v-form ref="form" :disabled="!candidato.pode_atualizar_dados_pessoais">
    <v-card flat rounded="lg">
      <v-card-title class="subtitle-1 font-weight-bold primary--text"
        >Dados de identificação</v-card-title
      >
      <v-card-text class="pb-0">
        <v-row dense>
          <v-col xl="4" lg="4" md="4" cols="12">
            <v-text-field
              label="Meu ID"
              v-model="candidato.id"
              disabled
            ></v-text-field>
          </v-col>
          <v-col xl="4" lg="4" md="4" cols="12">
            <v-text-field
              label="*CPF"
              v-model="candidato.cpf"
              disabled
            ></v-text-field>
          </v-col>
          <v-col xl="4" lg="4" md="4" cols="12">
            <v-text-field
              label="*Data de nascimento"
              type="date"
              v-model="candidato.dtnasc"
              disabled
            ></v-text-field>
          </v-col>
          <v-col xl="12" lg="12" md="12" cols="12">
            <v-text-field
              label="*Nome completo"
              v-model="candidato.nome"
              autofocus
              :rules="[(v) => !!v || 'Informe seu nome completo']"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card flat rounded="lg">
      <v-card-title class="subtitle-1 font-weight-bold primary--text"
        >Nacionalidade/Localização</v-card-title
      >
      <v-card-text class="pb-0">
        <v-row dense>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-select
              label="*Nacionalidade"
              no-data-text="Nenhuma nacionalidade localizada"
              :items="nacionalidades"
              item-text="descricao"
              item-value="codigo"
              v-model="candidato.naturalidade"
              :rules="[(v) => !!v || 'Nacionalidade deve ser informada']"
            ></v-select>
          </v-col>
          <template v-if="candidato.naturalidade == 1">
            <v-col xl="1" lg="1" md="1" cols="12">
              <v-select
                label="*País"
                no-data-text="Nenhum país encontrado"
                :items="locais"
                item-value="codigo"
                item-text="descricao"
                v-model="candidato.pais"
                :rules="[(v) => !!v || 'País deve ser informado']"
              ></v-select>
            </v-col>
            <v-col xl="1" lg="1" md="1" cols="12">
              <v-select
                label="*UF"
                no-data-text="Nenhuma UF encontrada"
                :items="locais.find((l) => l.codigo == candidato.pais).ufs"
                item-text="codigo"
                item-value="codigo"
                v-model="candidato.uf"
                :rules="[(v) => !!v || 'UF deve ser informada']"
              ></v-select>
            </v-col>
            <v-col xl="4" lg="4" md="4" cols="12">
              <v-select
                label="*Cidade"
                no-data-text="Nenhuma cidade localizada"
                :items="getCidadesSelecionar()"
                item-value="codigo"
                item-text="descricao"
                v-model="candidato.cidade"
                :rules="[(v) => !!v || 'Cidade deve ser informada']"
              ></v-select>
            </v-col>
            <v-col xl="3" lg="3" md="3" cols="12">
              <v-text-field
                label="*Bairro"
                ß
                no-data-text="Nenhum bairro encontrado"
                :items="locais"
                item-value="codigo"
                item-text="descricao"
                v-model="candidato.bairro"
                :rules="[(v) => !!v || 'Bairro deve ser informado']"
              ></v-text-field>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card flat rounded="lg">
      <v-card-title class="subtitle-1 font-weight-bold primary--text"
        >Contato</v-card-title
      >
      <v-card-text class="pb-0">
        <v-row dense>
          <v-col xl="6" lg="6" md="6" cols="12">
            <v-text-field
              label="*Telefone 1"
              v-mask="'(##) #########'"
              v-model="candidato.telefone1"
              :rules="[(v) => !!v || 'Telefone deve ser informado']"
            ></v-text-field>
          </v-col>
          <v-col xl="6" lg="6" md="6" cols="12">
            <v-text-field
              label="Telefone 2"
              v-mask="'(##) #########'"
              v-model="candidato.telefone2"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card flat rounded="lg">
      <v-card-title class="subtitle-1 font-weight-bold primary--text"
        >Outros dados</v-card-title
      >
      <v-card-text>
        <v-row dense>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-select
              label="*Sexo"
              no-data-text="Nenhum opção disponível"
              :items="generos"
              item-text="descricao"
              item-value="codigo"
              v-model="candidato.sexo"
              :rules="[(v) => !!v || 'Sexo deve ser informado']"
            ></v-select>
          </v-col>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-select
              label="*Cútis"
              no-data-text="Nenhuma opção disponível"
              item-text="descricao"
              item-value="codigo"
              :items="cutis"
              v-model="candidato.cutis"
              :rules="[(v) => !!v || 'Cútis deve ser informada']"
            ></v-select>
          </v-col>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-text-field
              label="Peso (Kg)"
              v-mask="pesoMask"
              v-model="candidato.peso"
              suffix="kgs"
              :rules="[
                (v) => !!v || 'Peso deve ser informado',
                (v) =>
                  /^[0-9]{2,}$/.test(v) || 'Peso deve ter pelo menos 2 dígitos',
                (v) =>
                  (v >= 10 && v <= 300) || 'Peso deve estar entre 50kg e 200kg',
              ]"
            ></v-text-field>
          </v-col>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-text-field
              label="Altura (m)"
              v-model="candidato.altura"
              suffix="m"
              v-mask="'#.##'"
              :rules="[
                (v) => !!v || 'Altura é obrigatória',
                (v) =>
                  /^[1-2]\.\d{2}$/.test(v) ||
                  'Altura deve estar no formato X.XX',
                (v) =>
                  (v >= 1 && v <= 2.5) || 'Altura deve estar entre 1m e 2.50m',
              ]"
            ></v-text-field>
          </v-col>
          <v-col xl="6" lg="6" md="6" cols="12">
            <v-autocomplete
              underlined
              label="*Escolaridade"
              no-data-text="Nenhuma opção disponível"
              :items="escolaridades"
              item-text="descricao"
              item-value="codigo"
              v-model="candidato.codescolaridade"
              :rules="[(v) => !!v || 'Escolaridade deve ser informada']"
            ></v-autocomplete>
          </v-col>
          <v-col
            xl="6"
            lg="6"
            md="6"
            cols="12"
            v-if="anexarCertificadoConclusao()"
          >
            <v-file-input
              label="Anexo Certificado Conclusão Curso"
              v-model="anexos.certificado_conclusao"
              :success="candidato.imgCertConclusao"
              :messages="
                candidato.imgCertConclusao ? 'Documento já enviado' : ''
              "
              :rules="[]"
            ></v-file-input>
          </v-col>
          <v-col xl="6" lg="6" md="6" cols="12" v-if="isGraduacaoSuperior">
            <v-autocomplete
              underlined
              v-model="candidato.curso"
              :items="cursosSuperiores"
              item-text="descricao"
              item-value="codigo"
              label="*Curso superior"
              clearable
              :rules="[(v) => !!v || 'Curso deve ser informado']"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="candidato.pode_atualizar_dados_pessoais">
        <v-row v-if="candidato.nivel == 1">
          <v-col cols="12">
            <v-btn
              rounded
              depressed
              block
              class="green lighten-4 primary--text font-weight-bold"
              @click="validarDadosPessoais()"
              >Continuar <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <v-btn
              rounded
              depressed
              block
              class="green lighten-4 primary--text font-weight-bold"
              @click="atualizar()"
              >Atualizar dados pessoais</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
export default {
  computed: {
    ...mapState([
      "candidato",
      "generos",
      "cutis",
      "escolaridades",
      "nacionalidades",
      "locais",
      "anexos",
      "cursosSuperiores",
    ]),
    isGraduacaoSuperior() {
      const esc = this.escolaridades.find(
        (e) => e.codigo === this.candidato.codescolaridade,
      );
      return esc ? esc.graduacao : false;
    },
  },
  watch: {
    // Ao mudar a escolaridade, se for graduacao, busca os cursos
    "candidato.codescolaridade": function () {
      if (this.isGraduacaoSuperior) {
        this.getCursosSuperiores();
      }
    },
  },
  methods: {
    ...mapMutations(["addStep"]),
    ...mapActions(["confirmarInscricao", "getCursosSuperiores"]),
    getCidadesSelecionar() {
      if (this.candidato.uf && this.candidato.pais) {
        return this.locais
          .find((l) => l.codigo == this.candidato.pais)
          .ufs.find((uf) => uf.codigo == this.candidato.uf).cidades;
      }
      return [];
    },
    validarDadosPessoais() {
      if (this.$refs.form.validate()) {
        this.addStep();
      }
    },
    anexarCertificadoConclusao() {
      if (this.candidato.codescolaridade > 0) {
        const esc = this.escolaridades.find(
          (e) => e.codigo == this.candidato.codescolaridade,
        );
        return esc ? esc.graduacao : false;
      }
      return false;
    },
    async atualizar() {
      this.atualizando = true;
      const insc = await this.confirmarInscricao();
      if (insc) {
        this.$router.go();
      }
      this.atualizando = false;
    },
  },
  data: () => ({
    atualizando: false,
    pesoMask: createNumberMask({
      prefix: "",
      suffix: "",
      includeThousandsSeparator: false,
      allowNegative: false,
      allowDecimal: false,
      requireDecimal: false,
      integerLimit: 3,
      decimalLimit: 3,
      decimalSymbol: ".",
    }),
    alturaMask: createNumberMask({
      prefix: "",
      suffix: "",
      includeThousandsSeparator: false,
      allowNegative: false,
      allowDecimal: true,
      requireDecimal: true,
      integerLimit: 1,
      decimalLimit: 2,
      decimalSymbol: ".",
    }),
  }),
  mounted() {
    // Se a escolaridade já estiver selecionada como graduacao, busca ao carregar
    if (this.isGraduacaoSuperior) {
      this.getCursosSuperiores();
    }
  },
};
</script>

<style></style>
